// @flow
import React, { Component } from "react";

import type { UserFormType, ErrorsType } from "../../types/UserFormType";
import { ErrosDisplay, checkPassword } from "../../containers/ErrosDisplay";
import { StyledTextField, CancelButton, SubmitButton, CompleteMessage } from "imagus-components";
import { PasswordStrengthBox, checkPswStrength } from "../../../global/components/PasswordStrength";
import { logout } from "../../actions/userActions";

import Grid from "@material-ui/core/Grid";

const DEBOUNCETIME = 500;

const initialUserform: UserFormType = {
  errors: {},
  oldpassword: "",
  password: "",
  password2: "",
  loading: false,
  completed: false,
  passwordstrength: {
    uppercase: false,
    lowercase: false,
    number: false,
    length: false
  }
};

class ChangePasswordForm extends Component<*, UserFormType> {
  timeout: number;
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.state = initialUserform;
  }

  componentDidMount() {
    this.setState({ errors: {} }); //weird bug when close modal with erros displayed
  }

  handleChange = (e: Event & { currentTarget: HTMLInputElement }): * => {
    const name = e.currentTarget.name;
    const value = e.currentTarget.value;
    this.setState((state: UserFormType) => ({
      [name]: value,
      errors: {}
    }));

    //password strength check
    if (name === "password") {
      this.setState({
        passwordstrength: checkPswStrength(this.state.passwordstrength, value)
      });
    }

    if (name === "password" || name === "password2") {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function(){
        this.setState({ errors: checkPassword(this.state.errors, this.state.password, this.state.password2) });
      }.bind(this), DEBOUNCETIME);
    }
  }

  submit = async (e: Event): * => {
    e.preventDefault();
    e.stopPropagation();
    const errors = this.state.errors;

    if (Object.keys(errors).length === 0 && !Object.values(this.state.passwordstrength).includes(false)) {
      this.setState((): * => ({ "loading": true }));

      this.props.userChangePassword(
        this.state.oldpassword.trim(),
        this.state.password.trim(),
        (): * => {
          this.setState({ completed: true, loading: false });
        },
        (errors: ErrorsType): * => {
          this.setState((state: UserFormType): * => ({
            errors: errors,
            loading: false
          }));
        }
      );
    }
  }

  render(): React$Element<*> {
    const errors = this.state.errors;
    const loading = this.state.loading;
    if (this.state.completed) {
      return (
        <Grid container spacing={24} >
          <Grid item xs={1}></Grid>
          <Grid item xs={10}>
            <CompleteMessage
              title="Done"
              content="Your password has been changed successfully.<br>Please log in with new password."
              onClick={logout.bind(null, () => window.location.href = "/logoff")}
            />
          </Grid>
        </Grid>
      );
    }
    else {
      return (
        <form onSubmit={(!loading && this.submit) || undefined}>
          <Grid container spacing={8}>
            <Grid item xs={12}>
              <StyledTextField
                isRequired={true}
                label="Old Password"
                name="oldpassword"
                value={this.state.oldpassword || ""}
                onChange={this.handleChange}
                inpuType="password"
              />
            </Grid>
            <Grid item xs={12}>
              <StyledTextField
                isRequired={true}
                label="New Password"
                name="password"
                value={this.state.password}
                onChange={this.handleChange}
                inpuType="password"
              />
            </Grid>
            <Grid item xs={12}>
              <PasswordStrengthBox
                passwordstrength={this.state.passwordstrength}
                password={this.state.password}
              />
            </Grid>
            <Grid item xs={12}>
              <StyledTextField
                isRequired={true}
                label="Confirm Password"
                name="password2"
                value={this.state.password2}
                onChange={this.handleChange}
                inpuType="password"
              />
            </Grid>
            <Grid item xs={12}>
              <ErrosDisplay errors={errors} form="change password" />
            </Grid>
            <Grid item xs={12}>
              <div className="form-right-btn-block">
                <CancelButton onClick={this.props.onClose} />
                <SubmitButton loading={loading} disabled={Object.keys(errors).length > 0 || Object.values(this.state.passwordstrength).includes(false)} />
              </div>
            </Grid>
          </Grid>
        </form>
      );
    }
  }
}

export default ChangePasswordForm;
